import React from 'react';
var Api = require('./Config');

export default class AppJLog extends React.Component {
  constructor(props) {
    super(props);
    this.device_id = props.match.params.device_id;
    this.state = { data: [], loaded: false };
  }

  componentWillReceiveProps(props) {
    this.device_id = props.match.params.device_id;
    this.getData();
  }

  getData() {
    Api.getSugarPressureDataForDevice(this.device_id)
      .then((data) => {
        console.log(data);
        this.setState({ data, loaded: true });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.getData();
  }

  formatDate(isoFormatDateString) {
    var dateParts = isoFormatDateString.split('-');
    var jsDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2].substr(0, 2));
    return jsDate.getMonth() + 1 + '/' + jsDate.getDate() + '/' + jsDate.getFullYear();
  }

  showGraph(data) {
    //window.open("#/showChart/"+data.t_code);
    // alert(data.t_code);
    this.props.history.push('/showChart/' + data.t_code);
  }

  getSingleJourney(data, index) {
    return (
      <div
        key={index}
        className="panel panel-primary"
        onClick={() => {
          this.showGraph(data);
        }}
      >
        <div className="panel-heading">
          <div
            style={{
              display: 'flex',
              widht: '100%',
              justifyItems: 'space-between',
              flexDirection: 'row',
            }}
          >
            <div style={{ flex: 1, fontWeight: 'bolder', fontSize: 18 }}>{data.t_code}</div>
            <div> Start date {this.formatDate(data.journey_start_date)}</div>
          </div>
        </div>
        <div className="panel-body">{data.journey_name}</div>
      </div>
    );
  }

  render() {
    return (
      <div className="container">
        <div>
          <h4>Your Journey</h4>
        </div>
        {this.state.loaded && this.state.data.length == 0 && <div>You don't have any journeys for J-Log</div>}
        <div className="panel-group">
          {_.map(this.state.data, (a, index) => {
            return this.getSingleJourney(a, index);
          })}
        </div>
      </div>
    );
  }
}
